import React from 'react'
import useResponsive from '../hooks/useResponsive'

interface SuccessModalProps {
  isOpen: boolean
  onClose: () => void
  title?: string
  message?: string
  subMessage?: string
}

const SuccessModal: React.FC<SuccessModalProps> = ({ 
  isOpen, 
  onClose, 
  title = "Success",
  message = "Invite Sent Successfully", 
  subMessage = "Candidate has received screener invite!"
}) => {
  const isMobileOrTablet = useResponsive('lg')

  if (!isOpen) return null

  return (
    <>
      {/* Dark backdrop */}
      <div 
        className="modal-backdrop fade show" 
        style={{ 
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1040 
        }}
        onClick={onClose}
      />
      
      {/* Modal */}
      <div 
        className="modal fade show d-block" 
        style={{ zIndex: 1050 }}
        tabIndex={-1}
        role="dialog"
        aria-hidden="false"
      >
        <div 
          className="modal-dialog modal-dialog-centered"
          style={{ 
            maxWidth: isMobileOrTablet ? '90%' : '400px',
            margin: '0 auto'
          }}
        >
          <div 
            className="modal-content" 
            style={{
              borderRadius: '12px',
              border: 'none',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)'
            }}
          >
            {/* Header */}
            <div 
              className="modal-header" 
              style={{ 
                borderBottom: '1px solid #dee2e6',
                paddingBottom: '0.5rem',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <h5 
                className="modal-title" 
                style={{ 
                  fontWeight: 500, 
                  fontSize: '1.25rem',
                  color: '#333'
                }}
              >
                {title}
              </h5>
              <button 
                type="button" 
                className="btn-close" 
                onClick={onClose}
                aria-label="Close"
                style={{ 
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  padding: '8px'
                }}
              >
                <img 
                    src="/svgs/times.svg" 
                    alt="Close" 
                    style={{
                    width: '12px',
                    height: '12px'
                    }}
                />
              </button>
            </div>

            {/* Body */}
            <div 
            className="modal-body text-center" 
            style={{ 
                padding: '1rem 2rem 3rem 2rem',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '250px' // Set minimum height for the modal body
            }}
            >
            {/* Green checkmark icon */}
            <div style={{ marginBottom: '1.5rem' }}> {/* Increased margin */}
                <img 
                src="/svgs/greencheck.svg" 
                alt="Success"
                style={{ 
                    width: '48px',  // Made icon bigger
                    height: '48px'
                }}
                />
            </div>

            {/* Main message */}
            <h6 
                style={{ 
                color: '#11807A', 
                fontWeight: 500,
                fontSize: '1.25rem', // Slightly larger text
                marginBottom: '0.75rem', // Increased margin
                textAlign: 'center',
                lineHeight: '1.3'
                }}
            >
                {message}
            </h6>

            {/* Sub message */}
            <p 
                style={{ 
                color: '#666', 
                fontSize: '0.9rem', // Slightly larger sub text
                margin: 0,
                lineHeight: '1.5',
                textAlign: 'center',
                maxWidth: '90%'
                }}
            >
                {subMessage}
            </p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SuccessModal